var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsuarios(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 16.2852V8.28516C3 6.95907 3.52678 5.6873 4.46447 4.74962C5.40215 3.81194 6.67392 3.28516 8 3.28516H16C17.3261 3.28516 18.5979 3.81194 19.5355 4.74962C20.4732 5.6873 21 6.95907 21 8.28516V16.2852C21 17.6112 20.4732 18.883 19.5355 19.8207C18.5979 20.7584 17.3261 21.2852 16 21.2852H8C6.67392 21.2852 5.40215 20.7584 4.46447 19.8207C3.52678 18.883 3 17.6112 3 16.2852Z",
    stroke: "#01295F",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 14.7852C16.5 14.7852 15 16.7852 12 16.7852C9 16.7852 7.5 14.7852 7.5 14.7852",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 10.2852C8.36739 10.2852 8.24021 10.2325 8.14645 10.1387C8.05268 10.0449 8 9.91776 8 9.78516C8 9.65255 8.05268 9.52537 8.14645 9.4316C8.24021 9.33783 8.36739 9.28516 8.5 9.28516C8.63261 9.28516 8.75979 9.33783 8.85355 9.4316C8.94732 9.52537 9 9.65255 9 9.78516C9 9.91776 8.94732 10.0449 8.85355 10.1387C8.75979 10.2325 8.63261 10.2852 8.5 10.2852ZM15.5 10.2852C15.3674 10.2852 15.2402 10.2325 15.1464 10.1387C15.0527 10.0449 15 9.91776 15 9.78516C15 9.65255 15.0527 9.52537 15.1464 9.4316C15.2402 9.33783 15.3674 9.28516 15.5 9.28516C15.6326 9.28516 15.7598 9.33783 15.8536 9.4316C15.9473 9.52537 16 9.65255 16 9.78516C16 9.91776 15.9473 10.0449 15.8536 10.1387C15.7598 10.2325 15.6326 10.2852 15.5 10.2852Z",
    fill: "#01295F",
    stroke: "#01295F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsuarios);
export default __webpack_public_path__ + "static/media/usuarios.7519295ac88c0a16c30ecc50a9df0b36.svg";
export { ForwardRef as ReactComponent };